import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const bulkFileDownloadReq = (endpoint: string, tokens: any) => {
  return fetch(`${sitConfig(tokens).baseUrl}${endpoint}`, {
    method: 'GET',
    headers: sitConfig(tokens).headers,
  })
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { bulkFileDownloadReq }
